module.exports = "images/apple-icon-144x144.77996be24c3a712eb274a3440977e89b.png";